import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../shared/auth-guard';


// Componentes
import { ManagerComponent } from '../../app-manager/manager.component';
import { CliClientComponent } from '../../app-manager/client/cli-client/cli-client.component';
import { ClientComponent } from '../../app-manager/client/client.component';
import { CliTabsComponent } from '../../app-manager/client/cli-tabs/cli-tabs.component';
import { CliReceiverListComponent } from '../../app-manager/client/cli-receiver-list/cli-receiver-list.component';
import { CliAdhesionListComponent } from '../../app-manager/client/cli-adhesion-list/cli-adhesion-list.component';
import { CliCompanyInfoComponent } from '../../app-manager/client/cli-company-info/cli-company-info.component';
import { CliAccessibilityComponent } from '../../app-manager/client/cli-accessibility/cli-accessibility.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    SharedModule,
    RouterModule.forRoot([
      {
        path: 'cliente/accesibilidad',
        component: CliAccessibilityComponent,
        pathMatch: 'full'
      },
      {path: 'cliente', redirectTo: 'cliente', pathMatch: 'full'},
      {
        path: 'cliente',
        component: ManagerComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ClientComponent,
            children: [
              {
                path: 'nuevo-cliente',
                component: CliClientComponent,
                pathMatch: 'full'
              },
              {
                path: '',
                component: CliTabsComponent,
                children: [
                  {
                    path: '',
                    redirectTo: 'autorizaciones',
                    pathMatch: 'full'
                  },
                  {
                    path: 'autorizaciones',
                    component: CliAdhesionListComponent,
                    pathMatch: 'full'
                  },
                  {
                    path: 'receptores',
                    component: CliReceiverListComponent,
                    pathMatch: 'full'
                  }
                ]

              }
            ]
          }
        ]
      }
    ])
  ],
  providers: [AuthGuard],
  declarations: [
    ClientComponent,
    CliClientComponent,
    CliTabsComponent,
    CliReceiverListComponent,
    CliAdhesionListComponent,
    CliCompanyInfoComponent,
    CliAccessibilityComponent
  ]
})
export class ClientModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/client/client.module.ts